'use client'

/* eslint-disable no-lone-blocks */
/* eslint-disable react/function-component-definition */
/* eslint-disable react/jsx-no-undef */
/* eslint-disable no-case-declarations */
import React from 'react'
import parse, { domToReact, attributesToProps } from 'html-react-parser'
import { domNodeToHtml } from '@components/Ackodrive/common/utils'
import { TableTopContainer, StyledTable, TD, TH, TableHyperlink, TableContainer } from './styles'

let index

const parsingOptions = {
  replace: domNode => {
    if (!domNode?.attribs) {
      return
    }
    if (domNode?.attribs && domNode?.name === 'a') {
      if (domNode.attribs.href.charAt(0) === '/') {
        return <a href={domNode?.attribs?.href}>{domNode?.children}</a>
      }
      if (domNode.attribs.href.includes('acko.com')) {
        return (
          <a href={domNode.attribs.href} target="_blank">
            {domToReact(domNode?.children, parsingOptions)}
          </a>
        )
      }
      return (
        <a
          href={domNode?.attribs?.href}
          target="_blank"
          aria-label={
            domNode.attribs.href.includes('acko.com') || domNode.attribs.href.includes('ackodrive.com')
              ? 'internal-link'
              : 'external-link'
          }
          rel={
            domNode?.attribs?.href.includes('acko.com') || domNode.attribs.href.includes('ackodrive.com')
              ? ''
              : 'noreferrer noopener nofollow'
          }>
          {domToReact(domNode?.children, parsingOptions)}
        </a>
      )
    }
  },
}

const options = {
  replace: domNode => {
    switch (domNode?.name) {
      case 'a':
        const props: any = attributesToProps(domNode?.attribs)
        switch (props?.href.includes('https://') || props?.href.includes('www.')) {
          case true: {
            return (
              <TableHyperlink
                href={props?.href}
                aria-label={
                  props?.href?.includes('acko.com') || props?.href?.includes('ackodrive.com')
                    ? 'internal-link'
                    : 'external-link'
                }
                rel={
                  props?.href?.includes('acko.com') || props?.href?.includes('ackodrive.com')
                    ? ''
                    : 'noreferrer noopener nofollow'
                }
                target="_blank">
                {domNode?.children}
              </TableHyperlink>
            )
          }

          case false: {
            return <TableHyperlink href={props?.href}>{domNode?.children}</TableHyperlink>
          }

          default: {
            {
              domToReact(domNode?.children, options)
            }
          }
        }
    }
  },
}

export default function Table({ content }) {
  const { tableStyle, alignment, body } = content?.data[0]?.attributes

  index = 0

  return (
    <TableTopContainer id="table-content-ad">
      <TableContainer>
        <StyledTable tableStyle={tableStyle || 'Bordered'} alignment={alignment}>
          {parse(body || '', renderTableOptions)}
        </StyledTable>
      </TableContainer>
    </TableTopContainer>
  )
}

export const renderTableOptions = {
  replace: domNode => {
    index++
    if (domNode?.name === 'h2') {
      return <React.Fragment key={`A${index}`}>{domToReact(domNode?.children, tableHeadOptions)}</React.Fragment>
    }
    if (domNode?.children?.length > 1) {
      const updatedRow: any = [
        {
          type: 'text',
          data: domNodeToHtml(domNode, true),
        },
      ]
      return <React.Fragment key={`C${index}`}>{domToReact(updatedRow, tableWithLinkOptions)}</React.Fragment>
    }
    return <React.Fragment key={`B${index}`}>{domToReact(domNode?.children, tableOptions)}</React.Fragment>
  },
}

export const tableHeadOptions = {
  replace: domNode => {
    if (domNode?.type === 'text') {
      return (
        <tr>
          {domNode?.data
            ?.split('|')
            .reduce((children, textSegment, index) => [...children, <TH key={`${index}`}>{textSegment}</TH>], [])}
        </tr>
      )
    }
    if (domNode?.name === 'b') {
      return domNode?.children
    }
  },
}

export const tableWithLinkOptions = {
  replace: domNode => {
    if (domNode?.type === 'text') {
      return (
        <tr>
          {domNode?.data
            ?.split('|')
            .reduce(
              (children, textSegment, index) => [
                ...children,
                <TD key={index}>{parse(textSegment || '', parsingOptions)}</TD>,
              ],
              []
            )}
        </tr>
      )
    }
  },
}

export const tableOptions = {
  replace: domNode => {
    if (domNode?.type === 'text') {
      return (
        <tr>
          {domNode?.data
            ?.split('|')
            .reduce((children, textSegment, index) => [...children, <TD key={index}>{textSegment}</TD>], [])}
        </tr>
      )
    }
    if (domNode?.name === 'b') {
      return domNode?.children
    }
  },
}
